var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"epic-integration"},[_c('header',{staticClass:"header"},[_c('h1',[_vm._v("Epic Integration")])]),_c('main',{staticClass:"content"},[_c('section',{staticClass:"intro"})])])
}]

export { render, staticRenderFns }